import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { LegacyDevice } from 'console/device/device';
import { DeviceStateIndicator } from 'console/shared/components/indicators/device-state';
import { GPSIconWithInfo } from 'console/shared/components/indicators/gps/with-info';
import { PowerIcon } from 'console/shared/components/indicators/power';
import { ConnectionIconsWithInfo } from './connection-icons';
import { useDeviceSettingsButton } from 'features/device.settings.open/ui';
import { useAction } from 'shared/hooks/redux/hooks';
import { idleDidLeave } from 'console/idle/reducer';
import { requestGetAllStates } from 'console/redux/main-actions';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { ErrorBoundary } from 'shared/components/error-boundary';
export const DeviceHeader = memo(function DeviceHeader(props) {
    const { device } = props;
    const { id, iconState, gps_state, last_gps, capabilities, power_source, device_type, voltage, online, } = device;
    const SettingsButton = useDeviceSettingsButton(id);
    const idleLeave = useAction(idleDidLeave);
    const _requestGetAllStates = useAction(requestGetAllStates);
    const onClickName = useCallback(() => {
        if (isMediumUI()) {
            _requestGetAllStates();
            idleLeave();
        }
    }, []);
    return (_jsxs(ErrorBoundary, { children: [_jsxs(Box, { display: "flex", alignItems: "center", overflow: "hidden", flexGrow: 1, fontSize: "1.5rem", children: [_jsx(DeviceStateIndicator, { state: iconState }), _jsx(Typography, { variant: "h6", textAlign: "center", textOverflow: "ellipsis", overflow: "hidden", ml: 1, whiteSpace: "nowrap", color: "textPrimary", onClick: onClickName, children: device != null
                            ? LegacyDevice.display_name(device)
                            : 'Нет устройств' })] }), device && gps_state && (_jsx(GPSIconWithInfo, { gps: gps_state, last_gps: last_gps, device_id: id, online: online })), device && (_jsx(PowerIcon, { "data-tooltip": "power-icon", capabilities: capabilities, online: online, power_source: power_source, voltage: voltage, device_type: device_type })), device && (_jsx(Box, { "data-tooltip": "connection-icons", children: _jsx(ConnectionIconsWithInfo, { device_id: id }) })), _jsx(SettingsButton, {})] }));
});
